import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import trim from 'lodash/trim';
import SideBar from '@/components/side_bar/SideBar.vue';
import ChannelList from '@/components/channel_list/ChannelList.vue';
import MessageList from '@/components/message_list/MessageList.vue';
import MessageHeader from '@/components/message_header/MessageHeader.vue';
import MessageInput from '@/components/message_input/MessageInput.vue';
import UserInfo from '@/components/user_info/UserInfo.vue';
import UserList from '@/components/user_list/UserList.vue';
import TabText from '@/components/tab_text/TabText.vue';
import TabMenu from '@/components/tab_menu/TabMenu.vue';
import Level from '@/global/level.directive';
import UserDefs from '@/store/user/user.d';

const { mapState: mapChannelState } = createNamespacedHelpers('Channel');
const {
  mapState: mapUserState,
  mapActions: mapUserActions
} = createNamespacedHelpers('User');

export default {
  components: {
    ChannelList,
    MessageList,
    MessageHeader,
    MessageInput,
    SideBar,
    TabText,
    TabMenu,
    UserInfo,
    UserList
  },

  data: function() {
    return {
      keyword: '',
      searchResults: [],
      tabMenu: {
        items: {
          ['archive-own']: {
            label: 'You'
          }
        },
        currentTab: 'archive-own'
      }
    };
  },

  watch: {
    keyword: {
      handler: 'handleOnKeywordChange'
    }
  },

  created: function() {
    const level = Level.canAccess('archive.allChannels');
    if (level) {
      this.tabMenu.items['archive-all'] = {
        label: 'All Concierges'
      };
    }
  },

  computed: {
    ...mapChannelState({
      currentChannel: state => state.currentChannel
    }),

    ...mapUserState({
      currentUser: state => state.currentUser
    })
  },

  methods: {
    ...mapUserActions({
      userStore_searchUser: UserDefs.actions.searchUser
    }),

    handleOnKeywordChange: debounce(async function() {
      if (trim(this.keyword) === '') {
        this.searchResults = [];
        return;
      }

      const results = await this.userStore_searchUser(this.keyword);
      this.searchResults = results;
    }, 1000),

    setChannelCount: function(channel) {
      const { items } = this.tabMenu;
      items[channel.tabName].count = channel.count;
    },

    setConciergeCount: function(concierges) {
      const { items } = this.tabMenu;
      items.concierges.count = concierges.length;
    }
  }
};
